import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from 'Component/Transform';
import Armature from 'Prototype/Armature';
import { AwaitIterators, ConcatIterators, PlayAnimation } from '../AnimationHelper';
import { DragonbonesFadeIn } from './DragonbonesFadeIn';
import { Slide } from './Slide';
import { Easing } from '@tweenjs/tween.js';
import { Container } from 'pixi.js';
import { Alpha } from './Alpha';
import TextComponent from 'Component/Render/Text';
import { DragonbonesDefault } from 'System/Animation/Clip/DragonbonesDefault';

interface IShowPlinkoRewardMeta {
    shadowArmature: Armature;
    rewardArmature: Armature;
    jackpotArmature: Armature;
    jackpot?: boolean;
    jackpotValue: GameObject;
    rewardIndex: number;
    rewardChildren: GameObject<Container>[];
    rewardCoinValue: number;
}

export class ShowPlinkoReward extends AnimationClip<IShowPlinkoRewardMeta> {
    public *execute(gameObject: GameObject, meta?: IShowPlinkoRewardMeta): IterableIterator<number> {
        const toAnimate = [];

        const { shadowArmature, rewardArmature, jackpotArmature, jackpotValue, rewardIndex, rewardChildren } = meta;

        jackpotValue.getComponent(TextComponent).text = meta.rewardCoinValue.toString();

        const component = gameObject.getComponent(TransformComponent);

        rewardArmature.getComponent(TransformComponent).position.x = component.position.x;

        const scaleTween = this.getTween(component.scale);
        scaleTween.to({ x: 1.4, y: 1.4 }, 300);
        toAnimate.push(this.startTween(scaleTween));

        const positionTween = this.getTween(component.position);
        positionTween.to({ x: component.position.x, y: component.position.y - 50 }, 300);
        toAnimate.push(this.startTween(positionTween));

        toAnimate.push(PlayAnimation(new DragonbonesFadeIn(shadowArmature)));
        toAnimate.push(PlayAnimation(new DragonbonesFadeIn(rewardArmature)));

        for (let i = 0; i < rewardChildren.length; i++) {
            if (i === rewardIndex) continue;
            const children = rewardChildren[i];
            toAnimate.push(
                PlayAnimation(
                    new Alpha(children, {
                        duration: 300,
                        startAlpha: 1,
                        endAlpha: 0.3,
                    })
                )
            );
        }

        if (meta.jackpot) {
            toAnimate.push(
                ConcatIterators([
                    PlayAnimation(new DragonbonesFadeIn(jackpotArmature, { animationName: 'start' })),

                    // Play jackpot idle animation after reward.
                    PlayAnimation(new DragonbonesDefault(jackpotArmature, { animationName: 'idle' })),
                ])
            );
            // Reset position for 2nd and 3rd animations.
            jackpotValue.getComponent(TransformComponent).position.set(-310, 60);
            toAnimate.push(
                PlayAnimation(
                    new Slide(jackpotValue, {
                        duration: 800,
                        x: 0,
                        y: 60,
                        easing: Easing.Back.Out,
                    })
                )
            );
        }

        yield* AwaitIterators(toAnimate);
    }
}
